import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App.jsx';
import ModeContextProvider from './components/context/ModeContext.jsx';
import GalleryContextProvider from './components/context/GalleryContext.jsx';
import NavContextProvider from './components/context/NavContext.jsx';
// import "./index.css";

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Router>
      <NavContextProvider>
        <GalleryContextProvider>
          <ModeContextProvider>
            <App />
          </ModeContextProvider>
        </GalleryContextProvider>
      </NavContextProvider>
    </Router>
  </StrictMode>
);
